export const strings = {
    investmentFund: 'Investment fund',
    fundInception: 'Fund inception',
    availableData: 'Available data',
    heading: 'Select the reporting period below',
    description:
        'The fund with the shortest available data period in your portfolio dictates the maximum reporting period available',
    investmentFundName: (index: number) => `Standard Life Future Advantage ${index + 1}`,
};
